import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { CMS_CONFIG, CmsConfig } from '@domgen/dgx-fe-cms';
import { DomainId, mergeObject } from '@domgen/dgx-fe-common';
import {
  DOMAIN_CONFIG,
  RUNTIME_CONFIG,
  domainIdFromDomain,
} from '@domgen/dgx-fe-config';
import { provideApp } from './app/app.provider';
import { AppComponent } from './app/components/app/app.component';
import { AppDomainConfig } from './app/models/domain/app-domain-config.interface';
import { AppRuntimeConfig } from './app/models/runtime/app-runtime-config.interface';
import { environment } from './environments/environment';

export function bootstrap() {
  return Promise.all([loadDomainConfig(), loadRuntimeConfig()])
    .then(([domainConfig, runtimeConfig]) => {
      if (environment.production) {
        enableProdMode();
      }

      const cmsConfig = mergeObject<CmsConfig>(
        environment.cms,
        runtimeConfig.cms
      );

      bootstrapApplication(AppComponent, {
        providers: [
          {
            provide: CMS_CONFIG,
            useValue: {
              ...cmsConfig,
              cmsRootPath: domainConfig.cmsRootPath,
            },
          },
          {
            provide: DOMAIN_CONFIG,
            useValue: domainConfig,
          },
          {
            provide: RUNTIME_CONFIG,
            useValue: runtimeConfig,
          },
          provideApp(),
        ],
      }).catch((error) => {
        console.error(error);
      });
    })
    .catch((error) => {
      console.error(error);
    });
}

async function loadDomainConfig(): Promise<AppDomainConfig> {
  const domainId: DomainId = domainIdFromDomain(
    environment.defaultDomainId,
    environment.domainIdMapping
  );

  const response = await fetch(`configs/domains/${domainId}.json`);
  return response.json();
}

async function loadRuntimeConfig(): Promise<AppRuntimeConfig> {
  const response = await fetch(
    `configs/deployments/config.${environment.name}.json`
  );
  return response.json();
}
